import { z } from 'zod';

import { type EstateSchemaType, getCreateEstateSchema } from '@/features/estates/schemas/estate';
import { i18n } from '@/lib/i18n';

export const emptyAddressData: EstateSchemaType['addressData'] = {
  address: '',
  addressAutoComplete: '',
  postalCode: '',
  city: '',
  countryId: '',
  street: '',
  houseNumber: '',
};

const tRequiredField = (field: string) => {
  return i18n.t('required-field', { field: i18n.t(field) });
};

export const getCreateEstateProjectSchema = () =>
  getCreateEstateSchema({ isAddressRequired: false }).superRefine((data, ctx) => {
    if (!data.addressData.addressAutoComplete?.trim() && !data.addressData.address.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: tRequiredField('address'),
        path: ['addressData', 'addressAutoComplete'],
      });
      return;
    }

    const hasRequiredAddressFields = [
      data.addressData.street,
      data.addressData.houseNumber,
      data.addressData.postalCode,
      data.addressData.city,
      data.addressData.countryId,
    ].every((value) => typeof value === 'string' && value.trim().length > 0);

    if (hasRequiredAddressFields) return;

    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: i18n.t('completeRequiredAddressFields'),
      path: ['addressData', 'addressAutoComplete'],
    });
  });
